import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { ProductsService } from '../../services/products.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  // available languages (kept for backwards compatibility with older specs)
  public languages: string[] = ['en'];
  // translations removed
  defaultImage: boolean = false;
  username: string | null = '';
  email: string | null = '';
  selectedLang: string = 'en';
  isProfileMenuOpen = false;

  constructor(
    private router: Router,
    private login: LoginService,
    private snackBar: MatSnackBar,
    private productService: ProductsService,
  ) {}

  ngOnInit() {
    // translations removed - preserve language selection from localStorage if present
    this.selectedLang = localStorage.getItem('language') || 'en';
    const token = this.login.getToken();
    if (token) {
      this.username = this.login.getUser().username;
      this.email = this.login.getUser().email;
    }
  }

  switchLanguage(lang: string): void {
    // language switching disabled - remember selection locally
    localStorage.setItem('language', lang);
    this.selectedLang = lang;
  }

  toggleProfile(): void {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  toggleSidenav(): void {
    this.productService.toggleSidenav();
  }

  logout(): void {
    const token = localStorage.getItem('token');
    if (token) {
      this.login.logout(token).then(() => {
        // translations removed - show fixed logout message
        this.snackBar.open('You have been successfully logged out', 'Close', {
          duration: 3000,
          panelClass: ['snackbar-success'],
        });
      });
    }
  }
}
